module.exports = __webpack_public_path__ + "static/media/videoOverview.8a82e231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoOverview.png
// module id = 412
// module chunks = 0